module.exports = __webpack_public_path__ + "media/images/plan-4120f4e63027bb1817837ec9f3464259.png";